module.exports = __webpack_public_path__ + "img/375.70980bd3.jpg";